import React, { FC } from 'react'
import styles from 'styles/components/header.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { State } from 'index'
import { getRole, getStoreRef } from 'reducks/auth/selectors'
import { Role } from 'lib/role'
import { initShop } from 'reducks/shop/operations'
import { initStore } from 'reducks/store/operations'
import { initConfirm } from 'reducks/confirm/operations'
import { HeaderNavChildMenu } from 'components/Header'

type Props = {
  label: string
  handleMenuClose: () => void
  requiredRole: number
  url: string
  icon?: string
  onClick?: () => void
  childMenus?: { label: string; url: string }[]
}

const HeaderNavMenuItem: FC<Props> = React.memo((props) => {
  const { label, handleMenuClose, icon, onClick, childMenus, requiredRole, url } = props

  const dispatch = useDispatch()

  const role = useSelector((state: State) => getRole(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const roleManager = new Role(role, storeRef)

  // 権限不足であればメニューを表示しない
  if (!roleManager.hasEnoughRole(requiredRole)) return <></>

  return (
    <li>
      <a
        className={styles.nav__list__item}
        role={'button'}
        data-cy={'header-nav-menu'}
        onClick={() => {
          handleMenuClose()
          if (onClick) {
            dispatch(onClick())
          }
          dispatch(push(url))
          // 管理者用メニューの場合
          if (requiredRole === 0) {
            dispatch(initConfirm())
            dispatch(initShop())
            dispatch(initStore())
          }
        }}
      >
        {icon && (
          <div className={styles.nav__list__item__icon}>
            <img src={`/icon/menu/${icon}.svg`} alt={label} />
          </div>
        )}
        <Spacer size={12} axis={'horizontal'} />
        <span className={styles.nav__list__item__label}>{label}</span>
        <img className={styles.nav__list__item__arrow} src={'/icon/menu/next.svg'} alt={`${label}を開く`} />
      </a>
      {childMenus && <HeaderNavChildMenu childMenus={childMenus} handleMenuClose={handleMenuClose} />}
    </li>
  )
})

export default HeaderNavMenuItem
